import React, { useState, useEffect } from 'react';

import { AmazonProfile } from '../../models/Profile';

import './Setup.globalBilling.scss';
import Select from '../Forms/Select';
import DateBillExample from '../visuals/DateBill.example';
import { Subject } from 'rxjs';

import moment from '../../services/unifiedMoment';
import { debounceTime } from 'rxjs/operators';
import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import GraphQlClient from '../../services/graphql';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import SwitchCheckbox from '../Forms/SwtichCheckbox';
import FiscalpopAutoGlobalDialog from './Setup.selfBilling.global.dialog';

function SetupGlobalBilling({ amazonProfile }: { amazonProfile: AmazonProfile }) {
    const [billGlobalEnabled, setBillGlobalEnabled] = useState(amazonProfile.billGlobalDayEnabled);
    const [isLoading, setIsLoading] = useState(false);

    const [displayNoLinkBefore, _setDisplayNoLinkBefore] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        if (!amazonProfile.billGlobalDayEnabled) {
            _setDisplayNoLinkBefore(false)
        } else if (amazonProfile.noGlobalBeforeTS && amazonProfile.noGlobalBeforeTS > moment().startOf('month').subtract(1, 'minute').valueOf()) {
            _setDisplayNoLinkBefore(true)
        } else {
            _setDisplayNoLinkBefore(false)
        }
        setBillGlobalEnabled(amazonProfile.billGlobalDayEnabled)
    }, [amazonProfile])


    const [setGlobalLimits] = useMutation(graphqlSchema.PROFILE.SETUP.setGlobalBillingLimits, {
        onCompleted: ({ setGlobalBillingLimits }) => {
            console.log('Updated Limits: ', setGlobalBillingLimits);
            GraphQlClient.modifyClientMLprofile(setGlobalBillingLimits);
            sharedToasterSubject.next({ type: 'confirm', message: `Actualizó tu proceso de facturación global` });

        },
        onError: () => {
        }
    })
    const [setGlobalEnabled] = useMutation(graphqlSchema.PROFILE.SETUP.setGlobalBillingEnabled, {
        onCompleted: ({ setGlobalBillingEnabled }) => {
            console.log('Updated Limits: ', setGlobalBillingEnabled);
            GraphQlClient.modifyClientMLprofile(setGlobalBillingEnabled);
            sharedToasterSubject.next({ type: 'confirm', message: `Actualizó tu proceso de facturación global` });
        },
        onError: () => {
        }
    })

    const [billGlobalDay, setBillGlobalDay] = useState<1 | 7 | 30>(amazonProfile.billGlobalDay || 7);
    const [subject] = useState(new Subject<1 | 7 | 30>());
    useEffect(() => {
        const paramSubs = subject.pipe(debounceTime(350)).subscribe((v: 1 | 7 | 30) => saveGlobalDay(v));
        return () => {
            paramSubs.unsubscribe();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleBillGlobalDayChange = (value: 1 | 7 | 30) => {
        setBillGlobalDay(value);
        subject.next(value);
    }

    const saveGlobalDay = (value: 1 | 7 | 30) => {
        console.log('[Global Setting] billGlobalDay: ', value);
        setGlobalLimits({
            variables: {
                billGlobalDay: value
            }
        })
    }

    const changeTsValue = () => {
        setIsLoading(true);
        setModalOpen(true);
    }

    const enableGlobalDay = () => {
        setIsLoading(true);
        // if(mercadoLibreProfile.billGlobalDayEnabled === null){
        if (!amazonProfile.billGlobalDayEnabled) {
            // This is first enabling of link functionality.
            // >> SelfBillingEnabled will be activated on noLinkBeforeTs method as well
            setModalOpen(true);
            return;
        }
        setBillGlobalEnabled(v => !v)
        setGlobalEnabled({
            variables: {
                billGlobalDayEnabled: !amazonProfile.billGlobalDayEnabled
            }
        })
    }

    const formatExampleForGlobal = () => {
        if (billGlobalDay === 1) {
            const nowMom = moment();
            const lastGlobalAutoMom = moment().subtract(3, 'days');
            const numericalRange = nowMom.year() === lastGlobalAutoMom.year() ?
                (nowMom.dayOfYear() + 1 - (lastGlobalAutoMom.dayOfYear() - 1))
                : (nowMom.dayOfYear() + 1 + 365 - (lastGlobalAutoMom.dayOfYear() - 1));
            const minAdjust = Math.ceil(3 * .10);

            const exampleProps = {
                numericalRange: numericalRange + minAdjust,
                originValue: numericalRange - 1 + minAdjust,
                originLabel: 'Hoy',
                referenceValue: (numericalRange - 1) - 3 + minAdjust,
                referenceDay: lastGlobalAutoMom.format('ddd, DD MMM'),
                referenceLabel: 'Última factura global a emitir'
            }

            return exampleProps;
        } else if (billGlobalDay === 7) {
            const nowMom = moment();
            const lastGlobalAutoMom = moment().subtract(3, 'day').startOf('week').subtract(1, 'day').endOf('week');
            const numericalRange = nowMom.year() === lastGlobalAutoMom.year() ?
                (nowMom.dayOfYear() + 1 - (lastGlobalAutoMom.dayOfYear() - 1))
                : (nowMom.dayOfYear() + 1 + 365 - (lastGlobalAutoMom.dayOfYear() - 1));
            const minAdjust = 0;
            const exampleProps = {
                numericalRange: numericalRange + minAdjust,
                originValue: numericalRange - 1 + minAdjust,
                originLabel: 'Hoy',
                referenceValue: 1,
                referenceDay: lastGlobalAutoMom.format('ddd, DD MMM'),
                referenceLabel: 'Última factura global a emitir'
            }

            return exampleProps;
        } else {
            const nowMom = moment();
            const lastGlobalAutoMom = moment().startOf('month').subtract(1, 'day').endOf('month');
            const numericalRange = nowMom.year() === lastGlobalAutoMom.year() ?
                (nowMom.dayOfYear() + 1 - (lastGlobalAutoMom.dayOfYear() - 1))
                : (nowMom.dayOfYear() + 1 + 365 - (lastGlobalAutoMom.dayOfYear() - 1));
            const minAdjust = Math.ceil(numericalRange * .10);
            const exampleProps = {
                numericalRange: numericalRange + minAdjust,
                originValue: numericalRange - 1 + minAdjust,
                originLabel: 'Hoy',
                referenceValue: minAdjust,
                referenceDay: lastGlobalAutoMom.format('ddd, DD MMM'),
                referenceLabel: 'Última factura global a emitir'
            }
            return exampleProps;
        }
    }

    const onCloseDialog = (noGlobalBeforeTS?: number) => {
        if (!!noGlobalBeforeTS) {
            setBillGlobalEnabled(true);
        } else if (!amazonProfile.billGlobalDayEnabled) {
            setBillGlobalEnabled(false);
        }
        setIsLoading(false);
        setModalOpen(false);
    }


    const selectOptions = [
        { label: 'Semanal', value: 7 },
        { label: 'Mensual', value: 30 },
    ];
    const exampleProps = formatExampleForGlobal();
    return (
        <div className="card" id="SetupGlobalBilling">
            <div className="title">
                <h4>Facturación Global automática</h4>
                <SwitchCheckbox onChange={enableGlobalDay}
                    value={billGlobalEnabled}
                    disabled={false} />
            </div>
            <div className="enableEmbedded">
                {
                    displayNoLinkBefore ?
                        <p className="info">
                            No se agregaran a facturas globales pedidos anteriores a  <b onClick={changeTsValue}>{moment(amazonProfile.noGlobalBeforeTS).format('DD MMMM YYYY')}</b>
                        </p>
                        : ''
                }
                <p>
                    Emitir facturación global (a mostrador) de manera automática para los <b>CFDIs que no fueron reclamados.</b><br />
                </p>
                <div className="entries">
                    <Select
                        label="Periodo de facturación global"
                        options={selectOptions}
                        value={billGlobalDay}
                        displayLabel={true}
                        disabled={!amazonProfile.billGlobalDayEnabled || isLoading}
                        onChange={handleBillGlobalDayChange}
                    />
                </div>
                <div className="example">

                    <DateBillExample
                        {...exampleProps}
                    />
                </div>
            </div>
            <FiscalpopAutoGlobalDialog modalIsOpen={modalOpen} onCloseDialog={onCloseDialog} />
        </div>
    )
}

export default SetupGlobalBilling;
